module.exports = __webpack_public_path__ + "static/media/SF_UI_Display_Regular.03c308e8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/SF-UI-Display/SF_UI_Display_Regular.svg
// module id = 213
// module chunks = 0